<template>
  <div 
    class="mainNavsWrap" 
    :class="showNav ?  'max' : ''"
  >
    <img :src="menuImg" class="menuImg" @click="changeShow"/>
    <div class="mainNav" @click.self="changeShow">
      <ul class="mainNavList">
        <li
          v-for="item in mainNavsList"
          :key="item.id"
          class="itemLi"
        >
          <div 
            class="itemHead"
            :class="nowPage === item.id ? 'active' : ''"  
            @click="changeNav(item.id)"
          >
            {{item.title}}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { swiperMixin } from '@/utils/mixin.js'
import menuImg from '@/assets/img/menuImg.png'
import { mainNavsList } from './data'

export default {
  mixins: [swiperMixin],
  data () {
    return {
      showNav: false, // 是否展示遮罩弹窗
      menuImg, // 按钮
      mainNavsList, // 主导航列表
    }
  },
  computed: {
    nowPage () {
      return this.$store.state.nowPage
    }
  },
  methods: {
    changeShow () { // 更改隐藏显示
      this.showNav = !this.showNav
    },

    changeNav ( index ) { // 点击导航跳转
      this.changeShow()
      this.mySlideTo(index)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
@import './mainNavs.styl'
</style>